import React, { ReactNode } from "react";
import {
  Box,
  IconButton,
  Button as MuiButton,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import theme from "../../theme";

interface Props {
  variant?: "outlined" | "contained" | "text";
  label?: string;
  disabled?: boolean;
  loading?: boolean;
  icon?: ReactNode;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  onClick: () => void;
  tooltip?: string;
  type?: "button" | "submit" | "reset" | undefined;
  cancel?: boolean;
}

const Button: React.FC<Props> = (props) => {
  const {
    variant,
    label,
    disabled,
    color,
    icon,
    loading,
    onClick,
    tooltip,
    type,
    cancel,
  } = props;

  const md = useMediaQuery(theme.breakpoints.down("md"));

  const ButtonStyle = () => {
    let buttonColor = !!cancel ? "inherit" : color;
    let buttonVariant = !!cancel ? "contained" : variant;

    return (
      <>
        {!!loading ? (
          <LoadingButton
            onClick={onClick}
            startIcon={icon}
            color={buttonColor}
            loading={loading}
            variant={buttonVariant}
            type={type || "button"}
          >
            {label}
          </LoadingButton>
        ) : !label ? (
          <IconButton
            color={buttonColor}
            onClick={onClick}
            disabled={disabled}
            type={type || "button"}
          >
            {icon}
          </IconButton>
        ) : (
          <MuiButton
            startIcon={icon}
            color={buttonColor}
            variant={buttonVariant}
            disabled={disabled}
            disableElevation
            onClick={onClick}
            type={type || "button"}
            size={md ? "small" : "medium"}
          >
            {label}
          </MuiButton>
        )}
      </>
    );
  };

  return !!tooltip ? (
    <Tooltip title={tooltip}>
      <Box>
        <ButtonStyle />
      </Box>
    </Tooltip>
  ) : (
    <ButtonStyle />
  );
};

export default Button;
